<template>
    <div class="scv-app-catalog-detail-main">
        <!-- 戻るボタン（上部固定） -->
        <div class="scv-btn-return-area">
            <button class="scv-btn-design-FRONTENDEX-MOBILE-APP-square-FRONTENDEX-MOBILE-APP scv-btn-color-white-FRONTENDEX-MOBILE-APP"
                    v-bind:class="{ 'scv-btn-return-delete-border': 0 == detail_scrollY }"
                    @click="onReturnBtn"
                    id="appcatalog-detail-view-return-btn"
                    style="height: 40px; width: 72px; font-size: 16px; padding-left: 8px; padding-right: 0px;">
                <div class="d-flex align-items-center">
                    <img src="../assets/img/header_back_bl.svg" height="24" width="20">
                    戻る
                </div>
            </button>
        </div>

        <!-- メイン情報 -->
        <div class="scv-app-icon-name-area">
            <img class="scv-app-icon" :src="appInfo.artworkUrl100">
            <div class="scv-app-name-area">
                <div class="scv-text-title scv-text-default-color-main-FRONTENDEX-MOBILE-APP">{{appInfo.trackName}}</div>
                <div class="scv-text-sub-title scv-text-default-color-sub-FRONTENDEX-MOBILE-APP" style="margin-top: 8px;">{{appInfo.sellerName}}</div>
                <div class="mt-auto" style="padding-top: 20px;">
                    <templete v-if="!appInfo.isRequestInstallUpdate">
                        <button type="button"
                                class="scv-btn-design-FRONTENDEX-MOBILE-APP scv-btn-color-light-blue-FRONTENDEX-MOBILE-APP scv-btn-size-m-FRONTENDEX-MOBILE-APP"
                                style="height: 28px;"
                                @click="onBtnInstallUpdate(appInfo)"
                                v-bind:disabled="((appInfo.isInstalled) && (!appInfo.hasUpdateAvailable) && ('0B' != appInfo.fileSizeBytes))">
                            <template v-if="appInfo.isInstalled">
                                <span>アップデート</span>
                            </template>
                            <template v-else>
                                <span>インストール</span>
                            </template>
                        </button>
                    </templete>
                    <template v-else>
                        <div class="scv-spinner-border-FRONTENDEX-MOBILE-APP scv-app-detail-spinner-border spinner-border"></div>
                    </template>
                </div>
            </div>
        </div>
        <!-- メモ -->
        <div v-if="appInfo.explanation.length > 0" class="scv-separator-line-list-FRONTENDEX-MOBILE-APP scv-separator-margin"></div>
        <div v-if="appInfo.explanation.length > 0" class="d-flex flex-column">
            <div class="scv-text-info scv-text-default-color-main-FRONTENDEX-MOBILE-APP" style="word-break: break-all; white-space:pre-wrap">{{appInfo.explanation}}</div>
        </div>
        <div v-if="appInfo.explanation.length > 0" style="height: 24px;"></div>
        <!-- 説明 -->
        <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP" style="margin-bottom: 24px;"></div>
        <template v-if="readMoreActivated || !isReadMeOmit">
            <div v-html="appInfo.description" id="read-me-app-info" class="overflow-auto scv-text-info-description scv-text-default-color-main-FRONTENDEX-MOBILE-APP"></div>
        </template>
        <template v-else>
            <div class="scv-read-me-area">
                <div v-html="appInfo.description" id="read-me-app-info" class="scv-read-me-omit scv-text-info-description scv-text-default-color-main-FRONTENDEX-MOBILE-APP"></div>
                <a @click="onReadMoreBtn" class="scv-read-me-more-button scv-text-info-description">さらに表示</a>
            </div>
        </template>
        <div style="height: 8px;"></div>
        <!-- アップデート -->
        <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP scv-separator-margin"></div>
        <div class="scv-text-title scv-text-default-color-main-FRONTENDEX-MOBILE-APP">アップデート</div>
        <div style="height: 20px;"></div>
        <div class="d-flex flex-row">
            <div class="scv-text-version scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">バージョン {{appInfo.version}}</div>
            <div class="scv-text-version scv-text-default-color-sub-FRONTENDEX-MOBILE-APP ms-auto">{{appInfo.currentVersionReleaseDate}}</div>
        </div>
        <div style="height: 20px;"></div>
        <div class="overflow-auto" style="max-height: 100px;">
            <div v-html="appInfo.releaseNotes" class="scv-text-info-description scv-text-default-color-main-FRONTENDEX-MOBILE-APP"></div>
        </div>
        <div style="height: 8px;"></div>
        <!-- 情報 -->
        <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP scv-separator-margin"></div>
        <div class="scv-text-title scv-text-default-color-main-FRONTENDEX-MOBILE-APP">情報</div>
        <div style="height: 20px;"></div>
        <div class="scv-item-box">
            <div class="scv-text-sub-title scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">販売元</div>
            <div class="scv-text-info scv-text-default-color-main-FRONTENDEX-MOBILE-APP ms-auto">{{appInfo.sellerName}}</div>
        </div>
        <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP scv-separator-margin"></div>
        <div class="scv-item-box">
            <div class="scv-text-sub-title scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">サイズ</div>
            <div class="scv-text-info scv-text-default-color-main-FRONTENDEX-MOBILE-APP ms-auto">{{appInfo.fileSizeBytes}}</div>
        </div>
        <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP scv-separator-margin"></div>
        <div class="scv-item-box">
            <div class="scv-text-sub-title scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">カテゴリ</div>
            <div class="scv-text-info scv-text-default-color-main-FRONTENDEX-MOBILE-APP ms-auto">{{appInfo.genres}}</div>
        </div>
        <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP scv-separator-margin"></div>
        <div class="d-flex flex-column">
            <div class="scv-text-sub-title scv-text-default-color-sub-FRONTENDEX-MOBILE-APP" style="margin-bottom: 8px;">互換性</div>
            <template v-if="appInfo.isExistsiPhone">
                <div class="scv-text-compatibility-title scv-text-default-color-main-FRONTENDEX-MOBILE-APP" style="margin-bottom: 4px;">iPhone</div>
                <div class="scv-text-info scv-text-default-color-main-FRONTENDEX-MOBILE-APP">iOS {{appInfo.minimumOsVersion}}以降が必要です。</div>
            </template>
            <template v-if="appInfo.isExistsiPad">
                <template v-if="appInfo.isExistsiPhone">
                    <div style="height: 20px;"></div>
                </template>
                <div class="scv-text-compatibility-title scv-text-default-color-main-FRONTENDEX-MOBILE-APP" style="margin-bottom: 4px;">iPad</div>
                <div class="scv-text-info scv-text-default-color-main-FRONTENDEX-MOBILE-APP">iPadOS {{appInfo.minimumOsVersion}}以降が必要です。</div>
            </template>
            <template v-if="appInfo.isExistsiPodTouch">
                <template v-if="appInfo.isExistsiPhone || appInfo.isExistsiPad">
                    <div style="height: 20px;"></div>
                </template>
                <div class="scv-text-compatibility-title scv-text-default-color-main-FRONTENDEX-MOBILE-APP" style="margin-bottom: 4px;">iPod touch</div>
                <div class="scv-text-info scv-text-default-color-main-FRONTENDEX-MOBILE-APP">iOS {{appInfo.minimumOsVersion}}以降が必要です。</div>
            </template>
        </div>
        <div style="height: 8px;"></div>
        <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP scv-separator-margin"></div>
        <div class="scv-item-box">
            <div class="scv-text-sub-title scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">言語</div>
            <div class="scv-text-info scv-text-default-color-main-FRONTENDEX-MOBILE-APP ms-auto">{{appInfo.language}}</div>
        </div>
        <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP scv-separator-margin"></div>
        <div class="scv-item-box">
            <div class="scv-text-sub-title scv-text-default-color-sub-FRONTENDEX-MOBILE-APP">年齢制限</div>
            <div class="scv-text-info scv-text-default-color-main-FRONTENDEX-MOBILE-APP ms-auto">{{appInfo.contentAdvisoryRating}}</div>
        </div>
        <div class="scv-separator-line-list-FRONTENDEX-MOBILE-APP scv-separator-margin"></div>
        <div style="height: 8px;"></div>
    </div>
</template>

<script lang="ts">
    import { Options, Vue } from 'vue-class-component';
    import { AppInfo } from '@/models/AppCatalog/AppInfo';

    @Options({
        props: {
            appInfo: { type: Object, required: true }   // クラス：AppInfo
        }
        ,emits: [
            /**
             * @brief	「アップデート」ボタン「インストール」ボタンが押下
             * @param	AppInfo: 押下対象
             */
            "onInstallUpdate",

            /**
             * @brief	「戻る」ボタンが押下
             */
            "onReturnBtn"
        ]
    })
    
    export default class AppCatalogDetailView extends Vue {
        private appInfo!: AppInfo;
        private detail_scrollY = 0;
        private readMoreActivated = false;
        private isReadMeOmit = false;

        /**
         * マウント後
         */
        public mounted(): void {
            window.addEventListener('scroll', this.onScroll);
            const el = document.getElementById('read-me-app-info');
            if (null != el) {
                if (el.scrollHeight > 80) {
                    this.isReadMeOmit = true;
                }
            }
        }

        /**
         * アンマウント後
         */
        public unmounted(): void {
            window.removeEventListener('scroll', this.onScroll);
        }

        /**
         * スクロールイベント
         */
        private onScroll(): void {
            // スクロールが一番上のときに戻るボタンの枠線が変わる
            this.detail_scrollY = window.scrollY;
        }

        /**
         * 「アップデート」ボタン「インストール」ボタンが押下
         */
        private onBtnInstallUpdate(app: AppInfo): void {
            this.$emit("onInstallUpdate", app);
        }

        /**
         * 「戻る」ボタンが押下
         */
        private onReturnBtn(): void {
            this.$emit("onReturnBtn");
        }

        /**
         * 「さらに表示」ボタンが押下
         */
        private onReadMoreBtn(): void {
            this.readMoreActivated = true;
        }
    }
</script>

<style scoped>
    /* メイン画面 */
    .scv-app-catalog-detail-main {
        margin: 0px 20px 0px 20px;
    }

    /* 戻るボタン */
    .scv-btn-return-area {
        position: sticky; /* 上部固定 */
        top: 8px; /* 上の間隔 */
        z-index: 10; /* 上にしないとクリックしにくい */
    }

    /* 戻るボタンの枠線削除 */
    .scv-btn-return-delete-border {
        border-style: none;
    }

    /* アイコン情報(アイコンと名前) */
    .scv-app-icon-name-area {
        display: flex;
        flex-direction: row;
        margin-bottom: 20px;
        margin-top: 16px;   /* 56px - 40px(戻るの高さ) */
    }

    /* アイコン情報(名前) */
    .scv-app-name-area {
        display: flex;
        flex-direction: column;
        margin-left: 16px;
    }

    /* タイトル文字（アプリ名、アップデートなど） */
    .scv-text-title {
        font-size: 21px;
        font-weight: bold;
        line-height: 1;
    }

    /* サブタイトル文字 */
    .scv-text-sub-title {
        font-size: 15px;
        min-width: 100px;
        line-height: 1;
    }

    /* バージョン文字 */
    .scv-text-version {
        font-size: 14px;
        line-height: 1;
    }

    /* 情報文字(長い説明）*/
    .scv-text-info-description {
        font-size: 14px;
        line-height: 1.8;
    }

    /* 情報文字(内容）*/
    .scv-text-info {
        font-size: 15px;
        line-height: 1;
    }

    /* 項目*/
    .scv-item-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        min-height: 16px;   /* 上下マージン(16px)と合わせて48px*/
    }

    /* 互換性タイトル文字（iPhone, iPad, iPod） */
    .scv-text-compatibility-title {
        font-size: 12px;
        font-weight: bold;
    }

    /* アプリアイコン */
    .scv-app-icon {
        height: 120px;
        min-width: 120px;
        border-radius: 26px;
        border: 0.5px solid #E6EBF0;
    }

    /* セパレータのマージン */
    .scv-separator-margin {
        margin: 16px 0px 16px 0px;
    }

    /* 説明 */
    .scv-read-me-area {
        height: 80px;
        position: relative;
    }

    /* 説明の省略 */
    .scv-read-me-omit {
        overflow: hidden !important;
        height: 100%;
    }

    /* 説明のさらに表示ボタン */
    .scv-read-me-more-button {
        background-color: #fff;
        position: absolute;
        right: 0;
        bottom: -1px;
        padding-left: 16px;
        padding-top: 0;
        padding-bottom: 6px;
    }

    /* くるくる更新アイコン */
    .scv-app-detail-spinner-border {
        width: 28px;
        height: 28px;
    }
</style>